import axios from "axios";

let config = { config: "alma" };

export async function config_init() {
  const response = await axios.get("config/config.json");
  if (response) {
    //console.log(response.data);
    config = response.data;
  }
}

export { config };
